// extracted by mini-css-extract-plugin
export default {"secondaryButton":"secondary_secondaryButton__MmnU6"};